import React from "react"
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
} from "@material-ui/core"
import { Delete, KeyboardBackspace } from "@material-ui/icons"

export default function ModalCancelPiano({ isOpen, toggle, onExited, update }) {
  return (
    <Dialog open={isOpen} fullWidth={true} onClose={toggle} onExited={onExited}>
      <DialogTitle onClose={toggle}>Salonify - Cancella Abbonamento</DialogTitle>
      <DialogContent dividers>
        Sei sicuro di voler cancellare l'abbonamento a Salonify?
      </DialogContent>
      <DialogActions
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Button
          startIcon={<KeyboardBackspace />}
          variant="outlined"
          onClick={toggle}
        >
          Annulla
        </Button>
        <Button
          type="submit"
          title='Cancella Abbonamento'
          color='primary'
          size='small'
          variant="contained"
          onClick={() => {
            update()
          }}
          startIcon={<Delete />}
        >
          Cancella Abbonamento
        </Button>
      </DialogActions>
    </Dialog>
  )
}
